import { useEffect, useRef } from "react";
import { useWatch } from "react-hook-form";

import { useReviewFieldErrorClear, type ReviewFieldErrorClearOptions } from "./useReviewFieldErrorClear";

type ReviewFieldErrorClearWatcherProps = {
  fieldPath?: string;
  options?: ReviewFieldErrorClearOptions;
};

/**
 * Subscribes to programmatic field changes (setValue) for post-Review error clearing.
 * Only mount inside FormProvider — useWatch requires form context.
 */
export function ReviewFieldErrorClearWatcher({ fieldPath, options }: ReviewFieldErrorClearWatcherProps) {
  const tryClear = useReviewFieldErrorClear(fieldPath, options);
  const watchedValue = useWatch({ name: fieldPath ?? "", disabled: !fieldPath });
  const previousValueRef = useRef(watchedValue);
  useEffect(() => {
    const valueChanged = !Object.is(previousValueRef.current, watchedValue);
    previousValueRef.current = watchedValue;
    tryClear(watchedValue, valueChanged);
  }, [watchedValue, tryClear]);
  return null;
}
